import { Component, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form } from '@angular/forms/signals';
import { ETipoDocumentoPromocion } from '@core/enums/tipoDocumentoPromocion.enum';
import { IPromocionImpresoraData } from '@core/interfaces/entidades/promocion-impresora.entidad';
import { IOptionsSelect } from '@core/interfaces/options.select.interface';
import { ICrearPromocionImpresoraReq } from '@core/interfaces/request-response/promocion-impresora.dto.interface';
import { PromocionImpresoraApiService } from '@core/services/api/promocion-impresora-api.service';
import { ToastService } from '@shared/services/toast.service';
import { buildDiff } from '@shared/utils/functions.utils';
import { UiSelect } from '@shared/components/ui';

@Component({
  selector: 'app-editar-promocion-impresora',
  imports: [FormField, UiSelect],
  templateUrl: './editar-promocion-impresora.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './editar-promocion-impresora.css',
})
export class EditarPromocionImpresora implements OnInit {
  ngOnInit(): void {
    this.tiposDocumento = Object.values(ETipoDocumentoPromocion);
    this.opcionesTipoDocumento.set(
      this.tiposDocumento.map((t) => ({ label: t === 'TODOS' ? 'Todos' : t, value: t })),
    );
    this.formPromocion().value.set({
      nombre: this.promocion().nombre || '',
      contenido: this.promocion().contenido || '',
      tipo_documento: this.promocion().tipo_documento || ETipoDocumentoPromocion.TODOS,
      monto_minimo: this.promocion().monto_minimo ?? null,
      activo: this.promocion().activo ?? true,
    });
  }
  private toastService = inject(ToastService);
  private api = inject(PromocionImpresoraApiService);

  promocion = input.required<IPromocionImpresoraData>();
  tiposDocumento: ETipoDocumentoPromocion[] = [];
  opcionesTipoDocumento = signal<IOptionsSelect<ETipoDocumentoPromocion>[]>([]);
  formPromocion = form(
    signal({
      nombre: '',
      contenido: '',
      tipo_documento: ETipoDocumentoPromocion.TODOS,
      monto_minimo: null as number | null,
      activo: true,
    }),
  );
  cerrar = output<IPromocionImpresoraData | undefined>();

  cancelar() {
    this.cerrar.emit(undefined);
  }
  guardar($event: Event) {
    $event.preventDefault();
    const formValue = this.formPromocion().controlValue();
    const current: Partial<ICrearPromocionImpresoraReq> = {
      nombre: formValue.nombre,
      contenido: formValue.contenido,
      tipo_documento: formValue.tipo_documento,
      monto_minimo: formValue.monto_minimo,
      activo: formValue.activo,
    };
    const original: ICrearPromocionImpresoraReq = {
      nombre: this.promocion().nombre,
      contenido: this.promocion().contenido,
      tipo_documento: this.promocion().tipo_documento,
      monto_minimo: this.promocion().monto_minimo,
      activo: this.promocion().activo,
    };
    const dataToSave: Partial<ICrearPromocionImpresoraReq> = buildDiff(original, current);
    if (!Object.keys(dataToSave).length) {
      this.cerrar.emit(undefined);
      return;
    }
    this.api.editar(this.promocion().id, dataToSave).subscribe({
      next: (data) => {
        this.toastService.show(
          'top-right',
          'success',
          'Promoción',
          'Promoción editada correctamente.',
        );
        this.cerrar.emit(data);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Promoción',
          err.error?.message || 'Error al editar la promoción.',
        );
      },
    });
  }
}
